<ng-container class="lang">
  <div class="lang-text lang-container {{currentLangClass}}" (click)="onClick()" >
    <img src="{{currentFlagFilePath}}" class="lang-flag-image">
    <span class="lang-name">{{currentLangName}}</span>
    <i [attr.class]="'fa fa-caret-down'"></i>
  </div>
  <img src="{{flagFilePath}}" class="lang lang-image {{currentLangClass}}" (click)="onClick()">
</ng-container>
